<template>
  <PageTable />
</template>
<script>
import PageTable from './table'
export default {
  name: 'customerManage-riskCheck',
  components: { PageTable },
}
</script>
